import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Css/Hero.css";

import hero1Main from "../assets/aaa.png";
import hero1Top from "../assets/housemaid.jpg";

import hero2Main from "../assets/aaa.png";
import hero2Top from "../assets/babycare.webp";

import About from "./About"
import Services from "../Components/Services"
import CTA from "../Components/CTA"
import WhyChoose from "../Components/WhyChoose"
import Testimonial from "../Components/Testimonial"
// import Contact from "../Components/Contact"
import Servicecoverflowcarouselexample from "../New_Components/Servicecoverflowcarouselexample.jsx"

import Popup from '../Components/Popup.jsx';   // ✅ your popup import
import ServiceAreas from "./Serviceareas.jsx";


const slides = [
  {
    main: hero1Main,
    top: hero1Top,
    title: "24 Hours",
    highlight: "Patient Care Takers in Mumbai",
    // tag: "TANYA MAID AGENCY-----",
    description:
      "Reliable and professional maid services for daily household needs. Trusted, trained, and verified staff to keep your home clean and comfortable.",
  },
  {
    main: hero2Main,
    top: hero2Top,
    title: "Mumbai's No.1",
    highlight: "Maid Service Provider",
    // tag: "TANYA MAID AGENCY-----",
    description:
      "Providing experienced housemaids, cooks, and domestic helpers across Mumbai. Quality service, quick placement, and complete peace of mind.",
  },
];

const Hero = () => {
  const [current, setCurrent] = useState(0);

  // Auto slide
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === slides.length - 1 ? 0 : prev + 1
    );
  };

  const slide = slides[current];

  return (
    <>
    <Popup/>
    <section className="hero">
      {/* Bottom Image */}
      <img
        src={slide.main}
        alt="Hero background"
        className="hero-bg hero-bg-main"
        key={slide.main}
      />

      {/* Top Image */}
      <img
        src={slide.top}
        alt="Hero overlay"
        className="hero-bg hero-bg-top"
        key={slide.top}
      />

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="hero-content">
        <span className="hero-tag">{slide.tag}</span>

        <h1 className="hero-title">
          {slide.title} <span>{slide.highlight}</span>
        </h1>

        {/* ✅ DESCRIPTION ADDED */}
        <p className="hero-desc">
          {slide.description}
        </p>

        <div className="hero-buttons">
          <Link to="/about-us" className="btn primary">
            Discover More
          </Link>
          <Link to="/contact" className="btn outline">
            Contact Us
          </Link>
        </div>
      </div>

      {/* Slider Arrows */}
      <div className="hero-arrows">
        <button
          className="arrow left"
          onClick={prevSlide}
          aria-label="Previous Slide"
        >
          ‹
        </button>

        <button
          className="arrow right"
          onClick={nextSlide}
          aria-label="Next Slide"
        >
          ›
        </button>
      </div>
    </section>
<Servicecoverflowcarouselexample />
    <About/>
    <Services/>
    <ServiceAreas />
    <CTA/>
    <WhyChoose/>
    <Testimonial/>
    {/* <Contact/> */}
<section className="contact-map">
        <iframe
          title="Tanya Maid Services Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7541.039524177508!2d72.90551!3d19.084841!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c78ca22b8b01%3A0x618abd782986f3b2!2sTANYA%20MAID%20SERVICES!5e0!3m2!1sen!2sin!4v1770359696044!5m2!1sen!2sin"
          loading="lazy"
          allowFullScreen
        ></iframe>
      </section>

    </>
  );
};

export default Hero;
